import { Dispatch, AnyAction } from 'redux';
import createAction from './create-action';

/**
 * ACTION TYPES
 */
export const APP_UPDATE_STATE = 'app:updateState';

export const APP_NAVIGATE_SPACE = 'app:navigateSpace';

export const APP_SET_CURRENT_LOADED_SPACE = 'app:setCurrentLoadedSpace';

export const APP_SET_CURRENT_SPACE = 'app:setCurrentSpace';

/**
 * ACTIONS
 */

export const updateAppState = (data: any) => (dispatch: Dispatch<AnyAction>) => {
  return dispatch(
    createAction(APP_UPDATE_STATE, data, {
      __PARSABLE__: false,
    })
  );
};

export const setLoadedSpace = (data: any) => (dispatch: Dispatch<AnyAction>) => {
  return dispatch(
    createAction(APP_SET_CURRENT_LOADED_SPACE, data, {
      __PARSABLE__: false,
    })
  );
};

export const setSpace = (data: any) => (dispatch: Dispatch<AnyAction>) => {
  return dispatch(
    createAction(APP_SET_CURRENT_SPACE, data, {
      __PARSABLE__: false,
    })
  );
};

export const navigateSpace = (data: any) => (dispatch: Dispatch<AnyAction>) => {
  return dispatch(
    createAction(APP_NAVIGATE_SPACE, data, {
      __PARSABLE__: false,
    })
  );
};
